import { GridColumn, GridDataRow, GridTable } from "@homebound/beam";
import React from "react";
import { ScopePageRows } from "../ProductOfferingScopePage";

type ProductOfferingScopeTableComponentProps = {
  columns: GridColumn<ScopePageRows>[];
  rows: GridDataRow<ScopePageRows>[];
};

function ProductOfferingScopeTableComponent({ columns, rows }: ProductOfferingScopeTableComponentProps) {
  return (
    <>
      <GridTable
        as="virtual"
        style={{ allWhite: true, bordered: true }}
        columns={columns}
        rows={rows}
        stickyHeader
        fallbackMessage={"No items match the applied filters. Please adjust and try again"}
      />
    </>
  );
}

export const ProductOfferingScopeTable = React.memo(ProductOfferingScopeTableComponent);
